/* eslint array-callback-return: "off" */

export function checkParam(obj: Record<string, unknown>) {
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'object' && value !== null) {
      checkParam(value as Record<string, unknown>);
    }
    if (value === undefined || value === null) {
      throw new Error(`${key} is a mandatory parameter`);
    }
  }
}
